import React from 'react';
import classNames from 'classnames';
import ContactForm from 'modules/static-pages/contact-page/components/contact-form';
import ContactStructuredData from 'modules/static-pages/contact-page/components/contact-structured-data';

import './contact-page.base.scss';

const ContactBase: React.FC = () => (
    <div className={classNames(
        {
            contact: true
        })}
    >
        <div className="contact row">
            <div className="col col-12">
                <h1>Kontakt</h1>
                <p>Jeśli chcesz poznać lepiej Skąpiec.pl, nasze produkty i usługi, zgłosić uwagi lub pomysły, jesteśmy
                    do
                    Twojej dyspozycji!
                </p>
                <br />
                <p>
                    Numer telefonu do kontaktu: 12 26 00 200 (pon-pt od 9:00 do 17:00).
                </p>
                <br /><br />
                <p className="description">
                    Najczęściej poruszane tematy opisaliśmy w&nbsp;rozdziale
                    <a className="link" href="/site/doc/4">„Najczęściej zadawane pytania”</a>.
                    Zapraszamy także do skorzystania z&nbsp;poniższego formularza kontaktu. Wybierając rodzaj wiadomości
                    sprawisz, że szybko dotrze ona do właściwej osoby, dzięki czemu będziemy mogli szybko na nią
                    odpowiedzieć.
                </p>
            </div>
            <div className="col col-12">
                <ContactForm />
            </div>
            <div className="col col-12">
                <small>
                    Administratorem danych osobowych podawanych do Umowy lub Umowy Szczegółowej jest <b>Ringier Axel
                    Springer Polska sp. z o.o.</b>
                    z siedzibą w Warszawie (02-672), ul. Domaniewska 49, zarejestrowana w rejestrze przedsiębiorców
                    Krajowego Rejestru Sądowego
                    prowadzonym przez Sąd Rejonowy dla m. st. Warszawy Wydział XIII Gospodarczy Krajowego Rejestru
                    Sądowego
                    pod numerem
                    KRS 0000420780, z kapitałem zakładowym w kwocie 106.000 zł, NIP: 5272677009, REGON: 146127300
                    („my”/”Skąpiec”),
                    kontakt elektroniczny pod adresem: <a href="mailto:bok@skapiec.pl"> bok@skapiec.pl </a>. Regulamin, który akceptujesz lub umowa,
                    którą
                    zawierasz jest prawną podstawą
                    przetwarzania Twoich danych. Dane podajesz dobrowolnie, jako niezbędne w celu świadczenia usług
                    zgodnie
                    z umową/regulaminem
                    oraz w zakresie koniecznym do jej/jego wykonania. Dane przetwarzamy również,
                    gdy jest to niezbędne do realizacji prawnie uzasadnionego interesu, jakim jest wobec Ciebie
                    marketing
                    bezpośredni naszych usług
                    i funkcjonalności w ramach Serwisu - masz prawo do sprzeciwu na takie przetwarzanie, kliknij by
                    wyświetlić pozostałe prawa dotyczące
                    przetwarzania danych: Wraz z podaniem danych przysługuje Ci prawo dostępu, sprostowania oraz
                    usunięcia
                    Twoich danych,
                    ograniczenia ich przetwarzania, wyrażenie sprzeciwu wobec przetwarzania, a także prawo złożenia
                    skargi
                    do organu nadzorczego
                    ochrony danych osobowych. W zakresie, w jakim ww. dane są przetwarzane w celu realizacji usług
                    Serwisu,
                    zgodnie z zaakceptowanym regulaminem (zawartą umową) lub są przetwarzane na podstawie zgody -
                    przysługuje Ci także prawo
                    do przenoszenia danych. Odbiorcą danych są podmioty obsługujące Skąpiec lub nasi podwykonawcy.
                    <br /><a href="/obowiazek-informacyjny">Kliknij</a>, by wyświetlić pozostałą część Obowiązku
                    Informacyjnego.
                </small>
            </div>
            <div className="col col-6 col-xs-12">
                <div className="box box--gray">
                    <strong>
                        Właścicielem serwisu Skapiec.pl jest firma:
                    </strong>
                    <br />
                    <br />
                    <p>
                        Ringier Axel Springer Polska sp. z o.o.
                        E-mail: <a href="mailto:skapiec@skapiec.pl"> skapiec@skapiec.pl </a>
                        Konto bankowe: 25 1240 6292 1111 0010 5999 9271
                    </p>
                </div>
            </div>
            <div className="col col-6 col-xs-12">

                <div className="box box--gray">
                    <strong>
                        Adres korespondencyjny
                    </strong>
                    <br />
                    <br />
                    <p>
                        Ringier Axel Springer Polska sp. z o.o.
                        ul. Marii Curie-Skłodowskiej 12, V piętro
                        50-381 Wrocław
                    </p>
                </div>
            </div>
        </div>
        <ContactStructuredData />
    </div>
);

export default ContactBase;
